import LambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';

export function fetchRavens(stage) {
    return LambdaUtil.getRavens(stage)
        .then(payload => {
            if (payload.status === 'ERROR') {
                throw new Error(`Error in ravens query. Payload = ${JSON.stringify(payload)}`);
            }
            if (!payload.ravens) {
                throw new Error(`Bad response format from ravens query. Payload = ${JSON.stringify(payload)}`);
            }
            return payload.ravens.ravens;
        });
}

export function fetchUsers(stage) {
    return LambdaUtil.getUsers(stage)
        .then(payload => {
            if (payload.status === 'ERROR') {
                throw new Error(`Error in users query. Payload = ${JSON.stringify(payload)}`);
            }
            if (!payload.users) {
                throw new Error(`Bad response format from users query. Payload = ${JSON.stringify(payload)}`);
            }
            return payload.users;
        });
}

export function fetchCurrentVehicleStates(stage, ravenUuids, selectedRavenUuid) {
    // Get the vehicle state for all given RavenUuids, plus dashboard for selected RavenUuid (given that it is in the list of RavenUuids)
    // allows the selected Raven UUID to be null or bogus.  It will only query the ravenUuids in the list
    return LambdaUtil.getCurrentVehicleStates(stage, ravenUuids, selectedRavenUuid)
        .then(payload => {
            if (payload.status === 'ERROR') {
                throw new Error(`Error in dashboard/currentVehicleStates query. Payload = ${JSON.stringify(payload)}`);
            }
            return payload;
        });
}

export function fetchDashboardAndVehicleStates(stage, ravenUuids) {
    return LambdaUtil.getRavenDashboardAndVehicleStates(stage, ravenUuids)
        .then(payload => {
            if (payload.status === 'ERROR') {
                throw new Error(`Error in dashboard/vehicleState query. Payload = ${JSON.stringify(payload)}`);
            }
            console.log('fetchDashboardAndVehicleStates payload = ', payload);
            return payload;
        });
}

export function fetchMediaIdsForCardEvents(stage, cardIds) {
    return LambdaUtil.getMediaIdsForCardEvents(stage, cardIds)
        .then(payload => {
            if (payload.status === 'ERROR') {
                throw new Error(`Error in events/mediaIds query. Payload = ${JSON.stringify(payload)}`);
            }
            return payload;
        });
}

